'use strict';

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loader from './loader.jsx';

const buildRoute = (name, path, exact = true) => (
  <Route
    exact={ exact }
    key={ name }
    path={ `/${ path !== undefined ? path : name }` }
    component={ (props) => (
      <Loader load={ () => System.import(`./${ name }.jsx`) }>
        {
          (Component) => Component == null ? null : <Component { ...props } />
        }
      </Loader>
    ) } />
);

export default [
  buildRoute(`login`),
  buildRoute(`projects`, `projects`, false),
  buildRoute(`account`, `account`, false),
  (
  <Redirect
    key={ `root` }
    exact
    from="/"
    to="/login" />),
  (
  <Route
      key={ `notfound` }
      component={ (props) => (
        <Loader load={ () => System.import(`./notfound.jsx`) }>
          {
            (Component) => Component == null ? null : <Component { ...props } />
          }
        </Loader>
      ) } />
  )
];



// WEBPACK FOOTER //
// ./src/routes/routes.js